import { useState, useEffect } from 'react';
import Edit from 'src/componentes/edit/edit-dialog';
import Input from 'src/componentes/input';
import { Schema } from 'src/utils/form';
import { Row, Col } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { capitalizeFirstLetter } from 'src/utils/string';
import http from 'src/services/httpService';
import useAuth from 'src/hooks/useAuth';

let schema = Schema.object({
  descricao: Schema.string()
    .label(<FormattedMessage id="descricao" />)
    .required()
    .addValidator(
      ({ value }) =>
        typeof value === 'string' && value.length > 0 && !value.trim()
    ),
  idIntegracao: Schema.string()
    .label(<FormattedMessage id="idIntegracao" />)
    .required({
      onlyIf: (context) => {
        return (
          !context.parent.value.utilizarCodigoAutomaticoConsequenciaRisco ||
          context.parent.value.id > 0
        );
      },
    }),
});

const FormEdit = (props) => {
  const { model, parameters } = props;
  const [configuracoes, setConfiguracoes] = useState(null);
  const [, setIsLoading] = useState(false);

  const loadConfiguracoes = () => {
    setIsLoading(true);

    http
      .post(`/ItemConfiguracaoRisco/ObterConfiguracoes`, {
        parameters,
      })
      .then((response) => {
        setConfiguracoes(response.data);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadConfiguracoes();
  }, []);

  const isNew = model?.getModel('id')?.value < 1;
  const {
    utilizarCodigoAutomaticoConsequenciaRisco,
    permitirAlterarCodigoAutomaticoConsequenciaRisco,
  } = configuracoes || {};

  const exibirIdIntegracao =
    !isNew || !utilizarCodigoAutomaticoConsequenciaRisco;

  return (
    <div>
      <Row>
        {exibirIdIntegracao && (
          <Col md={4}>
            <Input
              disabled={
                utilizarCodigoAutomaticoConsequenciaRisco &&
                !permitirAlterarCodigoAutomaticoConsequenciaRisco
              }
              model={model.getModel('idIntegracao')}
              required={!utilizarCodigoAutomaticoConsequenciaRisco || !isNew}
            />
          </Col>
        )}
        <Col md={exibirIdIntegracao ? 8 : 12}>
          <Input model={model.getModel('descricao')} required maxLength={400} />
        </Col>
      </Row>
    </div>
  );
};

const TratamentoRiscoEdit = (props) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  return (
    <Edit
      url="/ConsequenciaRisco"
      title={capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'labelConsequenciasDoRisco' },
          { consequencias: resources.consequencias, risco: resources.risco }
        )
      )}
      formComponent={FormEdit}
      schema={schema}
      width={600}
      height={300}
      {...props}
      showExport={false}
    />
  );
};

export default TratamentoRiscoEdit;
